module.exports = __webpack_public_path__ + "static/media/animal.5b8a3071.png";